module.exports = __webpack_public_path__ + "stylesheets/background_0b60b555c525afb02ce32c8952cb9fd8.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/background.less
// module id = kfHS
// module chunks = 154